export const openRTBValues = {
  smartphone: 4,
  tablet: 5,
  desktop: 2,
};

/**
 * Returns the OpenRTB_API standards value based on the device name
 *
 * @returns {integer}
 */
export const getOpenRTBValue = name => openRTBValues[name] || null;
